import React, { useState, useEffect } from "react";
import { userService } from "../../services/user.service";
import notify from "devextreme/ui/notify";
import { useDispatch, useSelector } from "react-redux";
import * as actions from '../../store/user/userActions';
import { ToastContainer } from "react-toastify";
import { Link } from 'react-router-dom';
import { getAppInfo } from "../../store/app/appActions";
import http from "../../utils/http";

function Login(props) {

    let username = props.location.state?.username;

    const { appInfo,  } = useSelector(store => store);

    const dispatch = useDispatch();
    const [user, setUser] = useState({ username: username ? username : "", password: "" });
    const [loading, setLoading] = useState(false);
    const [version, setVersion] = useState('Cargando...');

    const onValueChange = e => {

        setUser({
            ...user,
            [e.target.name]: e.target.value
        });

    }

    const sendUser = e => {
        e.preventDefault();
        setLoading(true);
        userService.login(user)
        .then(userResp => {

            dispatch(actions.updateUser({ username: userResp.username, areaId : userResp.areaId, area : userResp.area }));
            if (userResp.mustChangePassword) {

                props.history.push({ pathname: '/account/password', state: { username: userResp.username } });
                
            }else{
                
                let pathname = (props?.location?.state?.from?.pathname || '/app');
                
                pathname = pathname.includes('login') ? '/app' : pathname;
                
                props.history.push({ pathname });

            }

        }).catch(err => {
            setLoading(false)
            notify(err, "error")
        });

    }

    useEffect(() => {
        http('about/get-info').asGet()
            .then(resp => {
                setVersion(resp.version);
            })
            .catch(error => error);
    }, [0]);

    return (
        <React.Fragment>
            <ToastContainer autoClose={5000} hideProgressBar />
            <div className="wrapper-login">
                <form className="form-signin" onSubmit={sendUser}>
                    <div className="imglog">
                        <img className="nav-panel-logo" width={310} src={require('../../svg/homelogo.png')} />
                    </div>
                    <div style={{ paddingTop: 20 }}>
                        <h4>Iniciar sesión</h4>
                        <input value={user.username} onChange={onValueChange} type="text" className="form-control" name="username" placeholder="Usuario" required autoFocus={true} />
                        <input value={user.password} onChange={onValueChange} type="password" className="form-control" name="password" placeholder="Contraseña" required />
                    </div>
                    <input
                        className="btn btn-lg btn-primary btn-block custom-button" 
                        type="submit" 
                        value={loading ? "Iniciando..." : "Login"}                         
                        disabled={loading}/>
                    <br/>
                    <Link to={'/account/resetpassword'} >Olvidaste tu contraseña?</Link>
                    <div style={{color:'#d1d1d1',marginTop:20, fontSize:'12px', textAlign: 'center'}}>
                        Versión {version}
                    </div>
                </form>
            </div>
           
        </React.Fragment>
    );

}

export default Login;
